import React from "react";

import LoadingAnimation from "./animations/CrossLoadingAnimation";
import { Box, Fade } from "@mui/material";

export default function FullPageLoader({
    loading = true,
    ...props
}) {
    return <Fade
        unmountOnExit
        exit
        timeout={500}
        in={loading}>
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
            }}
            {...props}
        >
            <LoadingAnimation />
        </Box>
    </Fade>
};
